import { Main } from './Main'
import { Logic } from './Type'
import Socket from '../Socket/socket-init'
import * as RouteClasses from '../Socket/route-classes'
import { Cookies } from 'react-cookie'
// import * as Bet from '../Views/Main/Index/Bet'
// import * as Results from '../Views/Main/Index/Results'

export function getFlag(countryName: string): string {
    const flags = Object.assign(Socket.Get('flags'))
    for (const flag of flags.flags) {
        // if (country.name.indexOf('England') !== -1) console.log (country.name)
        if (flag.name === countryName
            || (countryName === 'Iran' && flag.name === 'Iran, Islamic Republic Of')
            || (countryName === 'Serbia' && flag.name === 'Republic of Serbia')
            || (countryName === 'Korea Republic' && flag.name === 'South Korea')
        )

            return flag.image40
    }
}

export function capitalizeFirstLetter(word: string): string {
    const x: string = word.toLowerCase()
    return x.charAt(0).toUpperCase() + x.slice(1)
}

export function logout() {
    const cookies = new Cookies()
    cookies.remove('playerId')
    cookies.remove('username')
    cookies.remove('nationality')
    cookies.remove('competitionTab')
    localStorage.clear()
    Socket.Set('login', {})
}

export function setCorrectScoresResult(item: any, matchId: number, homeTeam: string, awayTeam: string, match: number) {
    if (item) {
        const cookies = new Cookies()
        let found = false
        if (Main.Instance.Fantasy.chosenResults) {
            let results = Main.Instance.Fantasy.chosenResults.correctScores
            for (let i = 0; i < results.length; i++) {
                if (results[i].matchId === matchId) {
                    found = true
                    if (results[i].correctScore.name === item.name) {
                        results.splice(i, 1)
                        Main.Instance.Fantasy.selectedResult[match] = '---'
                        Logic.Type.New(Main.Instance.Fantasy, {selectedResult: Main.Instance.Fantasy.selectedResult})
                        localStorage.setItem('selectedResult', JSON.stringify(Main.Instance.Fantasy.selectedResult))
                    } else {
                        results[i].correctScore = item
                    }
                    for (let j = 0; j < Main.Instance.Fantasy.chosenResults.correctScores.length; j++) {
                        if (Main.Instance.Fantasy.chosenResults.correctScores[j].matchId === matchId) {
                            Main.Instance.Fantasy.chosenResults.correctScores[j] = {
                                matchId,
                                homeTeam,
                                awayTeam,
                                correctScore: item
                            }
                        }
                    }
                    Logic.Type.New(Main.Instance.Fantasy, { chosenResults: Main.Instance.Fantasy.chosenResults })
                    localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
                    break
                }
            }
        }
        if (found === false) {
            let chosenResults: RouteClasses.IBet
            if (Main.Instance.Fantasy.chosenResults) {
                chosenResults = Main.Instance.Fantasy.chosenResults
            } else {
                chosenResults = {
                    playerId: +cookies.get('playerId'),
                    round: +localStorage.getItem('roundId'),
                    correctScores: []
                }
            }
            if (Main.Instance.Fantasy.chosenResults && Main.Instance.Fantasy.chosenResults.correctScores.length > 2) {
                const selectedResult = Main.Instance.Fantasy.selectedResult
                selectedResult[match] = '---'
                Logic.Type.New(Main.Instance.Fantasy, { selectedResult })
                localStorage.setItem('selectedResult', JSON.stringify(Main.Instance.Fantasy.selectedResult))
                alert('You have already selected 3 matches.')
            } else {
                chosenResults.correctScores.push({
                    matchId,
                    homeTeam,
                    awayTeam,
                    correctScore: {
                        name: item.name,
                        odds: +item.odds,
                        odds1X2: item.odds1X2,
                        bonus: item.bonus,
                        outCome: item.outCome
                    }
                })
            }
            Logic.Type.New(Main.Instance.Fantasy, { chosenResults })
            localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
        }
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}

export function setAccumulatorBtts(item: any, matchId: number, match: number, type: number, homeTeam: string, awayTeam: string) {
    let selectedAcc = Main.Instance.Fantasy.selectedAcc
    let found = false
    if (Main.Instance.Fantasy.chosenResults.accumulator) {
        let results = Main.Instance.Fantasy.chosenResults.accumulator
        for (let i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true
                if (results[i].type === 'BTTS' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1)
                    Main.Instance.Fantasy.selectedAcc[match] = 0
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                } else {
                    results[i].correctScore = item
                    Main.Instance.Fantasy.selectedAcc[match] = type
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                }
                for (let j = 0; j < Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId,
                            homeTeam,
                            awayTeam,
                            type: 'BTTS',
                            correctScore: item
                        }
                    }
                }
                Logic.Type.New(Main.Instance.Fantasy, { chosenResults: Main.Instance.Fantasy.chosenResults })
                localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
                break
            }
        }
    }
    if (found === false) {
        let chosenResults = Main.Instance.Fantasy.chosenResults
        if (Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main.Instance.Fantasy.chosenResults.accumulator
        } else {
            chosenResults.accumulator = []
        }
        if (Main.Instance.Fantasy.chosenResults.accumulator && Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.')
        } else {
            chosenResults.accumulator.push({
                matchId,
                homeTeam,
                awayTeam,
                type: 'BTTS',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name },
            })
            Main.Instance.Fantasy.selectedAcc[match] = type
            Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
            localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
        }
        Logic.Type.New(Main.Instance.Fantasy, { chosenResults })
        localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}

export function setAccumulatorOver(item: any, matchId: number, match: number, type: number, homeTeam: string, awayTeam: string) {
    let selectedAcc = Main.Instance.Fantasy.selectedAcc
    let found = false
    if (Main.Instance.Fantasy.chosenResults.accumulator) {
        let results = Main.Instance.Fantasy.chosenResults.accumulator
        for (let i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true
                if (results[i].type === 'Over' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1)
                    Main.Instance.Fantasy.selectedAcc[match] = 0
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                } else {
                    results[i].correctScore = item
                    Main.Instance.Fantasy.selectedAcc[match] = type
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                }
                for (let j = 0; j < Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId,
                            homeTeam,
                            awayTeam,
                            type: 'Over',
                            correctScore: item
                        }
                    }
                }
                Logic.Type.New(Main.Instance.Fantasy, { chosenResults: Main.Instance.Fantasy.chosenResults })
                localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
                break
            }
        }
    }
    if (found === false) {
        let chosenResults = Main.Instance.Fantasy.chosenResults
        if (Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main.Instance.Fantasy.chosenResults.accumulator
        } else {
            chosenResults.accumulator = []
        }
        if (Main.Instance.Fantasy.chosenResults.accumulator && Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.')
        } else {
            chosenResults.accumulator.push({
                matchId,
                homeTeam,
                awayTeam,
                type: 'Over',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name, specialBetValue: item.specialBetValue },
            })
            Main.Instance.Fantasy.selectedAcc[match] = type
            Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
            localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
        }
        Logic.Type.New(Main.Instance.Fantasy, { chosenResults })
        localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}

export function setAccumulatorUnder(item: any, matchId: number, match: number, type: number, homeTeam: string, awayTeam: string) {
    let selectedAcc = Main.Instance.Fantasy.selectedAcc
    let found = false
    if (Main.Instance.Fantasy.chosenResults.accumulator) {
        let results = Main.Instance.Fantasy.chosenResults.accumulator
        for (let i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true
                if (results[i].type === 'Under' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1)
                    Main.Instance.Fantasy.selectedAcc[match] = 0
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                } else {
                    results[i].correctScore = item
                    Main.Instance.Fantasy.selectedAcc[match] = type
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                }
                for (let j = 0; j < Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId,
                            homeTeam,
                            awayTeam,
                            type: 'Under',
                            correctScore: item
                        }
                    }
                }
                Logic.Type.New(Main.Instance.Fantasy, { chosenResults: Main.Instance.Fantasy.chosenResults })
                localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
                break
            }
        }
    }
    if (found === false) {
        let chosenResults = Main.Instance.Fantasy.chosenResults
        if (Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main.Instance.Fantasy.chosenResults.accumulator
        } else {
            chosenResults.accumulator = []
        }
        if (Main.Instance.Fantasy.chosenResults.accumulator && Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.')
        } else {
            chosenResults.accumulator.push({
                matchId,
                homeTeam,
                awayTeam,
                type: 'Under',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name, specialBetValue: item.specialBetValue },
            })
            Main.Instance.Fantasy.selectedAcc[match] = type
            Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
            localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
        }
        Logic.Type.New(Main.Instance.Fantasy, { chosenResults })
        localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}

export function setAccumulatorDraw(item: any, matchId: number, match: number, type: number, homeTeam: string, awayTeam: string) {
    let selectedAcc = Main.Instance.Fantasy.selectedAcc
    let found = false
    if (Main.Instance.Fantasy.chosenResults.accumulator) {
        let results = Main.Instance.Fantasy.chosenResults.accumulator
        for (let i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true
                if (results[i].type === 'Draw' && results[i].correctScore.name === item.name) {
                    results.splice(i, 1)
                    Main.Instance.Fantasy.selectedAcc[match] = 0
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                } else {
                    results[i].correctScore = item
                    Main.Instance.Fantasy.selectedAcc[match] = type
                    Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
                    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
                }
                for (let j = 0; j < Main.Instance.Fantasy.chosenResults.accumulator.length; j++) {
                    if (Main.Instance.Fantasy.chosenResults.accumulator[j].matchId === matchId) {
                        Main.Instance.Fantasy.chosenResults.accumulator[j] = {
                            matchId,
                            homeTeam,
                            awayTeam,
                            type: 'Draw',
                            correctScore: item
                        }
                    }
                }
                Logic.Type.New(Main.Instance.Fantasy, { chosenResults: Main.Instance.Fantasy.chosenResults })
                localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
                break
            }
        }
    }
    if (found === false) {
        let chosenResults = Main.Instance.Fantasy.chosenResults
        if (Main.Instance.Fantasy.chosenResults.accumulator) {
            chosenResults.accumulator = Main.Instance.Fantasy.chosenResults.accumulator
        } else {
            chosenResults.accumulator = []
        }
        if (Main.Instance.Fantasy.chosenResults.accumulator && Main.Instance.Fantasy.chosenResults.accumulator.length > 2) {
            alert('You have already selected 3 matches.')
        } else {
            chosenResults.accumulator.push({
                matchId,
                homeTeam,
                awayTeam,
                type: 'Draw',
                correctScore: { odds: +item.odds, outCome: item.outCome, name: item.name },
            })
            Main.Instance.Fantasy.selectedAcc[match] = type
            Logic.Type.New(Main.Instance.Fantasy, { selectedAcc })
            localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
        }
        Logic.Type.New(Main.Instance.Fantasy, { chosenResults })
        localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}

export function setScorers(item: any, matchId: number, homeTeam: string, awayTeam: string, team: number) {
    let found = false
    let chosenResults = Main.Instance.Fantasy.chosenResults
    if (Main.Instance.Fantasy.chosenResults.goalscorers) {
        let results = Main.Instance.Fantasy.chosenResults.goalscorers
        for (let i = 0; i < results.length; i++) {
            if (results[i].matchId === matchId) {
                found = true
                const clicked = results.find((a) => (a.matchId === matchId && a.correctScore.id === +item.id))
                if (clicked) {
                    results.splice(results.indexOf(clicked), 1)
                } else {
                    if (Main.Instance.Fantasy.chosenResults.goalscorers.length < 3) {
                        results.push({
                            matchId,
                            homeTeam,
                            awayTeam,
                            correctScore: {
                                id: +item.id,
                                name: item.player,
                                odds: item.odds,
                                outCome: item.outCome
                            },
                            team
                        })
                    } else {
                        alert ('You have already selected 3 goalscorers.')
                    }
                }
                Logic.Type.New(Main.Instance.Fantasy, { chosenResults })
                localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
                break
            }
        }
    }

    if (found === false) {
        if (Main.Instance.Fantasy.chosenResults.goalscorers) {
            chosenResults.goalscorers = Main.Instance.Fantasy.chosenResults.goalscorers
        } else {
            chosenResults.goalscorers = []
        }
        if (Main.Instance.Fantasy.chosenResults && Main.Instance.Fantasy.chosenResults.goalscorers.length > 2) {
            alert('You have already selected 3 goalscorers.')
        } else {
            chosenResults.goalscorers.push({
                matchId,
                homeTeam,
                awayTeam,
                correctScore: {
                    id: +item.id,
                    name: item.player,
                    odds: item.odds,
                    outCome: item.outCome
                },
                team
            })
        }
        Logic.Type.New(Main.Instance.Fantasy, { chosenResults })
        localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
    }
    // console.log(Main.Instance.Fantasy.chosenResults)
}

export function fillChosenResults(matches: any, results: any) {
    const selectedCorrect = Main.Instance.Fantasy.selectedResult
    const selectedAcc = Main.Instance.Fantasy.selectedAcc
    const correctScores: RouteClasses.ICorrectScoreBet[] = []
    const accumulator: RouteClasses.ICorrectScoreBet[] = []
    const goalscorers: RouteClasses.ICorrectScoreBet[] = []
    for (const score of results.results.correctScores) {
        const oldScore: RouteClasses.ICorrectScoreBet = {
            matchId: score.matchId,
            homeTeam: score.homeTeam,
            awayTeam: score.awayTeam,
            correctScore: score.correctScore
        }
        correctScores.push(oldScore)
    }
    for (const score of results.results.accumulator) {
        const oldScore: RouteClasses.ICorrectScoreBet = {
            matchId: score.matchId,
            homeTeam: score.homeTeam,
            awayTeam: score.awayTeam,
            correctScore: score.correctScore,
            type: score.type
        }
        accumulator.push(oldScore)
    }
    for (const score of results.results.goalscorers) {
        const oldScore: RouteClasses.ICorrectScoreBet = {
            matchId: score.matchId,
            homeTeam: score.homeTeam,
            awayTeam: score.awayTeam,
            correctScore: score.correctScore,
            team: score.team
        }
        goalscorers.push(oldScore)
    }
    for (const match of matches.matches) {
        const correctFound = results.results.correctScores.find((elt) => +elt.matchId === +match.matchId)
        const accFound = results.results.accumulator.find((elt) => +elt.matchId === +match.matchId)
        if (correctFound) selectedCorrect[matches.matches.indexOf(match)] = correctFound.correctScore.name
        if (accFound) selectedAcc[matches.matches.indexOf(match)] = checkType(accFound.type)
    }
    const chosenResults: RouteClasses.IBet = {
        playerId: results.results.playerId,
        round: results.results.round,
        correctScores,
        accumulator,
        goalscorers
    }
    Logic.Type.New(Main.Instance.Fantasy, { chosenResults, selectedResult: selectedCorrect, selectedAcc })
    localStorage.setItem('chosenResults', JSON.stringify(Main.Instance.Fantasy.chosenResults))
    localStorage.setItem('selectedResult', JSON.stringify(Main.Instance.Fantasy.selectedResult))
    localStorage.setItem('selectedAcc', JSON.stringify(Main.Instance.Fantasy.selectedAcc))
}

function checkType(type: string): number {
    switch (type) {
        case 'BTTS':
            return 1
        case 'Over':
            return 2
        case 'Under':
            return 3
        default:
            return 4
    }
}

export function sortF(ob1, ob2) {
    if (ob1.position > ob2.position) {
        return 1;
    } else if (ob1.position < ob2.position) { 
        return -1;
    }

    // Else go to the 2nd item
    if (ob1.odds < ob2.odds) { 
        return -1;
    } else if (ob1.odds > ob2.odds) {
        return 1
    } else { // nothing to split them
        return 0;
    }
}


// WEBPACK FOOTER //
// ./src/Logic/Utils.ts